import { useTheme } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";
import Icon from "ui/atom/Icon";
import Link from "ui/atom/Link";

import Button from "ui/base/Button";
import Card from "ui/base/Card";


Tile.Checkbox = ({ value, click, title, description, action }) => {
	const style = {
		content: { alignItems: "center" },
		checkbox: { p: 0 }
	};

	return (
		<Tile>
			<Box gap={1} sx={style.content}>
				<Checkbox checked={value} color="tertiary" onChange={click} sx={style.checkbox} />
				<Box.Column>
					<Typography variant="subtitle1" color="text.secondary">{title}</Typography>
					<Typography variant="body3">{description}</Typography>
				</Box.Column>
			</Box>
			{action && action}
		</Tile>
	);
};

Tile.Icon = ({ icon, startAction, title, description, action, to, errors, loading }) => {
	const style = {
		content: { alignItems: "center" }
	};

	return (
		<Tile to={to}>
			<Box sx={style.content} gap={1.25}>
				{icon && <Icon name={icon} size="22px" />}
				{startAction && startAction}
				<Box.Column>
					<Typography variant="subtitle1" color="text.secondary">{title}</Typography>
					<Typography variant="body3">
						{loading
							? <Skeleton width="80px" />
							: description
						}
					</Typography>
					{errors && <Typography variant="subtitle1" color="error">{errors.join(" ")}</Typography>}
				</Box.Column>
			</Box>
			{action && action}
			{to && <Button.Icon icon="chevron-right" size={18} />}
		</Tile>
	);
};

export default function Tile({ children, to }) {
	const theme = useTheme();
	const style = {
		root: {
			justifyContent: "space-between",
			alignItems: "center",
			p: theme.spacing(1.5, 2),
			minHeight: "72px",
			backgroundColor: theme.palette.background.white,
			border: `1px solid ${theme.palette.background.white}`,
			borderRadius: "12px"
		}
	};

	return (
		<Card.Box elevation={5} sx={style.root} component={to && Link} to={to && to}>
			{children}
		</Card.Box>
	);
}